import { AppBar as MuiAppBar, AppBarProps as MuiAppBarProps, styled } from '@mui/material'
import { drawerWidth } from 'constants/layout'

interface AppBarProps extends MuiAppBarProps {
  isOpen?: boolean
}

export const AppBar = styled(MuiAppBar, { shouldForwardProp: (prop) => prop !== 'isOpen' })<AppBarProps>(
  ({ theme, isOpen }) => ({
    zIndex: theme.zIndex.drawer - 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(isOpen && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }),
)
